import './Dashboard.css';
import Sidebar from '../Sidebar/Sidebar';
import dashboard from './assets/img/dashboard.png';
import search from './assets/img/search.png';

// QR codes ZIP
import QRCode from "qrcode";
import JSZip from "jszip";
import { saveAs } from "file-saver";

import { useNavigate } from 'react-router-dom';
import { FloatButton, Checkbox, Spin, Pagination, Empty, Modal, Input, Form, Button, message, Popconfirm, Row, Col, Divider, Tooltip as AntdTooltip, Select, Card } from 'antd';
import { FilePdfOutlined, FileExcelOutlined, ExportOutlined, EyeOutlined, DeleteOutlined  } from '@ant-design/icons';
import { useState, useEffect, useMemo } from 'react';
import jsPDF from 'jspdf';
import axios from 'axios';
// Import Chart.js components
import { Pie, Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title } from 'chart.js';

import { Doughnut } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title);

function Dashboard() {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [selectAll, setSelectAll] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectAllFields, setSelectAllFields] = useState(false);

  // State for modal visibility and selected report
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [scriptData, setScriptData] = useState(null);
  const [daysRange, setDaysRange] = useState(365); 

  // States for Table (Huy Script)
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const reportsPerPage = 10;


  // Logout handler function
  function userLogout() {
    localStorage.removeItem('token');
    navigate('/');
  }

  // Profile navigation handler
  function goToProfile() {
    navigate('/profile');
  }

  // Function to open report details in a new tab
  function openReportDetails(reportid) {
    window.open(`/report/${reportid}`, '_blank');
  }

  // Function to delete a report
  const handleDeleteReport = async (reportId) => {
    try {
      await axios.delete(`/api/reports/${reportId}`);
      message.success('Report deleted successfully');

      // Update reports list after deletion
      setReports((prevReports) => prevReports.filter((report) => report.reportId !== reportId));
    } catch (error) {
      console.error('Error deleting report:', error);
      message.error('Failed to delete report');
    }
  };

  const handleUpdateReport = async (reportId, grade, reason, imageLink, videoLink) => {
    try {
      // Construct payload dynamically (include links only if provided)
      const payload = { grade, reason, imageLink, videoLink };
    
      await axios.put(`/api/report/${reportId}`, payload);
      message.success("Grade, reason, and media links updated successfully");
  
      // Update reports list after updating the report
      setReports((prevReports) =>
        prevReports.map((report) =>
          report.reportId === reportId
            ? { ...report, grade, reason, imageLink, videoLink }
            : report
        )
      );
  
      handleModalClose(); // Close modal after update
    } catch (error) {
      console.error("Error updating report:", error);
      message.error("Failed to update report");
    }
  };
  
  // // Function to handle opening the modal
  // const openUpdateModal = (report) => {
  //   setSelectedReport(report);
  //   setIsModalVisible(true);
  // };

  // // Function to handle modal close
  // const handleModalClose = () => {
  //   setIsModalVisible(false);
  //   setSelectedReport(null);
  // };

  // // Function to handle updating the report data
  // const handleUpdateReport = async (values) => {
  //   try {
  //     // Call the updateReportData function
  //     await axios.put(`/api/report/${selectedReport.imei}`, {
  //       grade: values.grade,
  //       value: values.value,
  //     });

  //     // Update the reports state with the updated data
  //     setReports((prevReports) =>
  //       prevReports.map((report) =>
  //         report.imei === selectedReport.imei
  //           ? { ...report, grade: values.grade, value: values.value }
  //           : report
  //       )
  //     );

  //     // Close the modal
  //     setIsModalVisible(false);
  //     setSelectedReport(null);
  //   } catch (error) {
  //     console.error('Error updating report:', error);
  //   }
  // };

  // Fetch reports from the API
  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get('/api/reports/dashboard');
  
        // Process reports data
        const fetchedReports = response.data.reports.map((report) => ({
          reportId: report.data.report.reportid,
          reportDate: report.data.report.finishtime,
          imei: report.data.report.IMEI,
          brand: report.data.report.Manufacturer,
          model: report.data.report.Model,
          value: report.data.report.value,
          grade: report.data.report.grade,
          status: report.data.report.reportstatus,
        }));
  
        setReports(fetchedReports);
  
        // Initialize checkbox state
        const initialCheckedState = fetchedReports.reduce((acc, report) => {
          acc[report.reportId] = false;
          return acc;
        }, {});
        setCheckedItems(initialCheckedState);
  
        setLoading(false);
      } catch (error) {
        console.error('Error fetching reports:', error);
        setLoading(false);
      }
    };
  
    fetchReports();
  }, []);
  

  const handleCheckboxChange = (reportId) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [reportId]: !prevState[reportId],
    }));
  };

  // Handle "Select All" for the current page
  const handleSelectAll = () => {
    setCheckedItems((prevState) => {
      const newCheckedItems = { ...prevState };
  
      if (selectAll) {
        currentReports.forEach((report) => delete newCheckedItems[report.reportId]);
      } else {
        currentReports.forEach((report) => {
          newCheckedItems[report.reportId] = true;
        });
      }
  
      return newCheckedItems;
    });
  
    setSelectAll(!selectAll);
  };  
 
  // Function to fetch and format report details by IMEI
  // const fetchReportDetails = async (reportid) => {
  //   try {
  //     const response = await axios.get(`/api/report/${reportid}`);
  //     const { report, extra } = response.data.data;
  
  //     // Extracting deeply nested values safely
  //     const partsReplaced = extra.json.PartsReplaced?.iOS || {};
  //     const batteryInfo = extra.json.DeviceInfo?.BatteryInfo[0] || {};
  
  //     return {
  //       reportId: report.reportid,
  //       startTime: report.starttime,
  //       finishTime: report.finishtime,
  //       imei: report.IMEI,
  //       serialNumber: report.serialnumber,
  //       deviceId: report.deviceid || 'N/A',
  //       manufacturer: report.Manufacturer,
  //       model: report.Model,
  //       os: report.os,
  //       operator: report.operator,
  //       reportStatus: report.reportstatus,
  //       reportResult: report.reportresult,
  //       reportType: report.reporttype,
  //       action: report.action,
  //       value: report.value || 'N/A',
  //       grade: report.grade || 'N/A',
  
  //       // Device Info
  //       countryOrigin: extra.json.DeviceInfo?.CountryOrigin || 'N/A',
  //       cpu: extra.json.DeviceInfo?.CpuName || 'N/A',
  //       cpuSpeed: extra.json.DeviceInfo?.CpuSpeed || 'N/A',
  //       ram: extra.json.DeviceInfo?.RAM || 'N/A',
  //       memorySize: extra.json.DeviceInfo?.HandsetMemorySize || 'N/A',
  //       deviceColor: extra.json.DeviceInfo?.DeviceColor || 'N/A',
  //       lcdResolution: extra.json.DeviceInfo?.LCDResolution || 'N/A',
  //       lcdSize: extra.json.DeviceInfo?.LCDSize || 'N/A',
  //       mdmStatus: extra.json.DeviceInfo?.MDMStatus || 'N/A',
  //       manufactureDate: extra.json.DeviceInfo?.ManufactureDate || 'N/A',
  //       productVersion: extra.json.DeviceInfo?.ProductVersion || 'N/A',
  //       originalProductVersion: extra.json.DeviceInfo?.OriginalProductVersion || 'N/A',
  //       softwareBuild: extra.json.DeviceInfo?.SoftwareBuild || 'N/A',
  //       rooted: extra.json.DeviceInfo?.Rooted || 'N/A',
  
  //       // Battery Info
  //       batteryHealth: batteryInfo.BatteryHealth || 'N/A',
  //       batteryCycleCount: batteryInfo.BatteryCycleCount || 'N/A',
  //       batteryGrading: batteryInfo.BatteryGrading || 'N/A',
  //       batteryFullChargeCapacity: batteryInfo.BatteryFullChargeCapacity || 'N/A',
  //       batteryDesignCapacity: batteryInfo.BatteryDesignCapacity || 'N/A',
  //       batterySerial: batteryInfo.BatterySerial || 'N/A',
  //       batteryTemp: batteryInfo.BatteryTemp || 'N/A',
  
  //       // Wipe Info
  //       wipeMethod: extra.json.DataWipeInfo?.WipeMethod || 'N/A',
  //       wipeStatus: extra.json.DataWipeInfo?.Status || 'N/A',
  
  //       // Analyst Info
  //       analystId: extra.json.AnalystInfo?.AnalystId || 'N/A',
  //       analystAppVersion: extra.json.AnalystInfo?.AnalystApplicationVersion || 'N/A',
  //       licenseId: extra.json.AnalystInfo?.LicenseId || 'N/A',
  //       licenseReportMode: extra.json.AnalystInfo?.LicenseReportMode || 'N/A',
  //       siteId: extra.json.AnalystInfo?.SiteID || 'N/A',
  //       profileName: extra.json.AnalystInfo?.ProfileName || 'N/A',
  //       testCaseFails: extra.json.AnalystInfo?.TestCaseFails || 'N/A',
  //       windowsPCName: extra.json.AnalystInfo?.WindowsPCName || 'N/A',
  //       userName: extra.json.AnalystInfo?.UserName || 'N/A',
  
  //       // Parts Replaced
  //       batteryStatus: partsReplaced.Battery?.result || 'N/A',
  //       lcdStatus: partsReplaced.LCD?.result || 'N/A',
  //       mainBoardStatus: partsReplaced.MainBoard?.result || 'N/A',
  //     };
  //   } catch (error) {
  //     console.error(`Failed to fetch report details for Report ID ${reportid}:`, error);
  //     return null;
  //   }
  // };  

  // Pagination
  const indexOfLastReport = currentPage * reportsPerPage;
  const indexOfFirstReport = indexOfLastReport - reportsPerPage;

  // Filter reports based on search query
  const filteredReports = reports.filter(
    (report) =>
      report.reportId.toString().includes(searchQuery) ||
      report.imei.toString().includes(searchQuery)
  );
  
  const sortedReports = [...filteredReports].sort((a, b) => new Date(b.reportDate) - new Date(a.reportDate));
  const currentReports = useMemo(() => sortedReports.slice(indexOfFirstReport, indexOfLastReport), [sortedReports, indexOfFirstReport, indexOfLastReport]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSelectAll(false); // Uncheck "Select All" when changing pages
  };

  // Export as PDF handler
  // const exportAsPDF = async () => {
  //   const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
  //   if (selectedReports.length === 0) {
  //     alert('Please select at least one record to export.');
  //     return;
  //   }

   
  // };

  // Export as CSV handler
  const allFields = [
    'Report-ID', 'Start-Time', 'Finish-Time', 'IMEI', 'Serial-Number', 'Device-ID', 'Manufacturer', 'Model', 'OS',
    'Operator', 'Report-Status', 'Report-Result', 'Report-Type', 'Action', 'Value', 'Grade', 
    // 'Country-Origin',
    'CPU', 'CPU-Speed', 'RAM', 'Memory-Size', 'Device-Color', 'LCD-Resolution',
    //  'LCD-Size', 'MDM-Status',
    'Manufacture-Date', 'Product-Version', 'Original-Product-Version', 'Software-Build', 'Rooted',

    // 'Battery-Health', 'Battery-Cycle-Count', 'Battery-Grading', 'Battery-Full-Charge-Capacity',
    // 'Battery-Design-Capacity', 'Battery-Serial-Number', 'Battery-Temp', 'Wipe-Method', 'Wipe-Status',


    'Analyst-ID', 'Analyst-App-Version', 'License-ID', 'License-Report-Mode', 'Site-ID',
    'Profile-Name', 'Test-Case-Fails', 'Windows-PC-Name', 'User-Name', 
    // 'Parts-Replaced-Battery',
    // 'Parts-Replaced-LCD', 'Main-Board-Status',
     'ANumber', 'BaseBand-Version', 'Build-Version', 'Cpu-Name', 'Decimal-MEID', 'Device-Enclosure-Color',
    'ECID', 'FMIP', 'Hardware-Model', 'Hardware-Platform', 'Model-Number', 'Region-Info',
    // 'Product-Type',
     'Battery-Manufacturer-Date', 
    // 'Battery-Overall-Percentage', 'Asset-Management',
    'Unique-License-ID', 'Finish-Date', 'Start-Date', 'Result', 'QR-Code-Link', 'Back-Image', 'Behind-Image', 
    'Font_LightAngle1-Image', 'Font_LightAngle2-Image', 'Font_LightAngle3-Image', 
    'Font_LightAngle4-Image', 'Font_LightAngle5-Image', 'Font_LightAngle6-Image', 
    'Font_LightAngle7-Image', 'Font_LightAngle8-Image', 'Front-Image', 'Report-Link',
  ];
  
  const toggleFieldSelection = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
    );
  };

  const handleSelectAllFields = () => {
    if (selectAllFields) {
      setSelectedFields([]);
    } else {
      setSelectedFields([...allFields]);
    }
    setSelectAllFields(!selectAllFields);
  };

  const handleExportClick = () => {
    setModalVisible(true);
  };

  const exportAsCSV = async () => {
    setModalVisible(false);

    if (selectedFields.length === 0) {
      alert('Please select at least one field to export.');
      return;
    }

    const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
    if (selectedReports.length === 0) {
      alert('Please select at least one record to export.');
      return;
    }

    const csvRows = [selectedFields];

    for (const report of selectedReports) {
      try {
        const response = await axios.get(`/api/report/${report.reportId}`);
        const reportData = response.data;
        const data = reportData.report.data.report || {};
        const deviceInfo = reportData.report.data.extra?.json?.DeviceInfo || {};
        const analystInfo = reportData.report.data.extra?.json?.AnalystInfo || {};
        const batteryInfo = reportData.report.data.extra?.json?.BatteryInfo?.[0] || {};

        const row = selectedFields.map((field) => {
          switch (field) {
            case 'Report-ID': return data.reportid || '';
            case 'Start-Time': return data.starttime || '';
            case 'Finish-Time': return data.finishtime || '';
            case 'IMEI': return data.IMEI || deviceInfo.IMEI || '';
            case 'Serial-Number': return data.serialnumber || deviceInfo.SerialNumber || '';
            case 'Device-ID': return data.deviceid || deviceInfo.DeviceId || '';
            case 'Manufacturer': return data.Manufacturer || deviceInfo.Manufacturer || '';
            case 'Model': return data.Model || deviceInfo.Model || '';
            case 'OS': return data.os || deviceInfo.OperatingSystem || '';
            case 'Operator': return data.operator || '';
            case 'Report-Status': return data.reportstatus || '';
            case 'Report-Result': return data.reportresult || '';
            case 'Report-Type': return data.reporttype || '';
            case 'Action': return data.action || '';
            case 'Value': return data.value || '';
            case 'Grade': return data.grade || '';
        
            // Device Info
            //case 'Country-Origin': return deviceInfo.CountryOrigin || '';
            case 'CPU': return deviceInfo.CPU || '';
            case 'Cpu-Name': return deviceInfo.CpuName || '';
            case 'CPU-Speed': return deviceInfo.CpuSpeed || '';
            case 'RAM': return deviceInfo.RAM || '';
            case 'Memory-Size': return deviceInfo.HandsetMemorySize || '';
            case 'Device-Color': return deviceInfo.DeviceColor || '';
            case 'ANumber': return deviceInfo.ANumber || '';
            case 'BaseBand-Version': return deviceInfo.BaseBandVersion || '';
            case 'Build-Version': return deviceInfo.BuildVersion || '';
            case 'Decimal-MEID': return deviceInfo.DecimalMEID || '';
            case 'Device-Enclosure-Color': return deviceInfo.DeviceEnclosureColor || '';
            case 'ECID': return deviceInfo.ECID || '';
            case 'FMIP': return deviceInfo.FMIP || '';
            case 'Hardware-Model': return deviceInfo.HardwareModel || '';
            case 'Hardware-Platform': return deviceInfo.HardwarePlatform || '';
            case 'Model-Number': return deviceInfo.ModelNumber || '';
            case 'Region-Info': return deviceInfo.RegionInfo || '';
            case 'Product-Type': return deviceInfo.ProductType || '';
            case 'MDM-Status': return deviceInfo.MDMStatus || '';
            case 'Manufacture-Date': return deviceInfo.ManufactureDate || '';
            case 'Product-Version': return deviceInfo.ProductVersion || '';
            case 'Original-Product-Version': return deviceInfo.OriginalProductVersion || '';
            case 'Software-Build': return deviceInfo.SoftwareBuild || '';
            case 'Rooted': return deviceInfo.Rooted || '';
        
            // Battery Info
            case 'Battery-Health': return batteryInfo?.[0]?.BatteryHealth || '';
            case 'Battery-Cycle-Count': return batteryInfo?.[0]?.BatteryCycleCount || '';
            case 'Battery-Grading': return batteryInfo?.[0]?.BatteryGrading || '';
            case 'Battery-Full-Charge-Capacity': return batteryInfo?.[0]?.BatteryFullChargeCapacity || '';
            case 'Battery-Design-Capacity': return batteryInfo?.[0]?.BatteryDesignCapacity || '';
            case 'Battery-Serial-Number': return batteryInfo?.[0]?.BatterySerial || '';
            case 'Battery-Temp': return batteryInfo?.[0]?.BatteryTemp || '';
            case 'Battery-Manufacturer-Date': return batteryInfo?.[0]?.BatteryManufacturerDate || '';
            case 'Battery-Overall-Percentage': return batteryInfo?.[0]?.BatteryOverallPercentage || '';
        
            // Analyst Info
            case 'Analyst-ID': return analystInfo.AnalystId || '';
            case 'Analyst-App-Version': return analystInfo.AnalystApplicationVersion || '';
            case 'License-ID': return analystInfo.LicenseId || '';
            case 'License-Report-Mode': return analystInfo.LicenseReportMode || '';
            case 'Site-ID': return analystInfo.SiteID || '';
            case 'Profile-Name': return analystInfo.ProfileName || '';
            case 'Test-Case-Fails': return analystInfo.TestCaseFails || '';
            case 'Windows-PC-Name': return analystInfo.WindowsPCName || '';
            case 'User-Name': return analystInfo.UserName || '';
            case 'Asset-Management': return analystInfo.AssetManagement || '';
            case 'Finish-Date': return analystInfo.FinishDate || '';
            case 'Start-Date': return analystInfo.StartDate || '';
            case 'Unique-License-ID': return analystInfo.UniqueLicenseId || '';
            case 'Result': return analystInfo.Result || '';
        
            // Links
            case 'QR-Code-Link': return `https://dymax.a2hosted.com/buybackbatch/qrcodes/${data.IMEI}.png`;
            case 'Report-Link': return `https://report.gearvu.io/report/${data.IMEI}`;

             // ✅ Image URLs
            case 'Back-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Back.jpg`;
            case 'Behind-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Behind.jpg`;
            case 'Font_LightAngle1-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle1.jpg`;
            case 'Font_LightAngle2-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle2.jpg`;
            case 'Font_LightAngle3-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle3.jpg`;
            case 'Font_LightAngle4-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle4.jpg`;
            case 'Font_LightAngle5-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle5.jpg`;
            case 'Font_LightAngle6-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle6.jpg`;
            case 'Font_LightAngle7-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle7.jpg`;
            case 'Font_LightAngle8-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle8.jpg`;
            case 'Front-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Front.jpg`;

        
            default: return '';
          }
        });

        csvRows.push(row);
      } catch (error) {
        console.error(`Error fetching data for Report ID: ${report.reportId}`, error);
      }
    }

    const csvContent = csvRows.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'exported_reports.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Export QR codes
  const exportQRCodes = async () => {
    console.log("Starting exportQRCodes function...");
  
    // Filter the selected reports based on checked items
    const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
    console.log(`Selected Reports Count: ${selectedReports.length}`);
  
    if (selectedReports.length === 0) {
      alert("Please select at least one record to export.");
      console.warn("No reports selected for QR code export.");
      return;
    }
  
    const zip = new JSZip();
    const folder = zip.folder("QRCodes");
  
    const promises = selectedReports.map(async (report) => {
      const qrCodeUrl = `https://report.gearvu.io/report/${report.reportId}`;
      console.log(`Generating QR code for Report ID: ${report.reportId}, IMEI: ${report.imei}`);
      console.log(`QR Code URL: ${qrCodeUrl}`);
  
      try {
        const qrCodeDataUrl = await QRCode.toDataURL(qrCodeUrl, { width: 300 });
        console.log(`QR Code generated for IMEI ${report.imei}`);
        
        const blob = await (await fetch(qrCodeDataUrl)).blob();
        console.log(`QR Code blob fetched for IMEI ${report.imei}`);
        
        folder.file(`${report.imei}.png`, blob);
        console.log(`QR Code added to zip for IMEI ${report.imei}`);
      } catch (error) {
        console.error(`Failed to generate QR code for IMEI ${report.imei}:`, error);
      }
    });
  
    await Promise.all(promises);
  
    zip.generateAsync({ type: "blob" }).then((content) => {
      console.log("ZIP file generated successfully.");
      saveAs(content, "QRCodes.zip");
      console.log("ZIP file download initiated.");
    }).catch((error) => {
      console.error("Failed to generate ZIP file:", error);
    });
  
    console.log("exportQRCodes function completed.");
  };
  
  
  // Function to handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // Allow only numeric input
      setSearchQuery(value);
    }
  };

  
   // Chart Data
  const valuedVsNonValuedData = {
    labels: ['Valued Phone', 'Non-Valued Phone'],
    datasets: [
      {
        label: 'Valued vs Non-Valued Phones',
        data: [
          reports.filter((report) => report.value).length,
          reports.filter((report) => !report.value).length,
        ],
        backgroundColor: ['#CCC', '#CE2E28'],        
      },
      
    ],
  };
  
  const totalReportsChartData = {
    labels: ['Completed', 'Not Completed'],
    datasets: [
      {
        label: 'Total inspected Reports',
        data: [
          reports.filter((report) => report.status === 'Completed').length,
          reports.filter((report) => report.status !== 'Completed').length,
        ],
        backgroundColor: ['#CCC', '#CE2E28'],
      },
    ],
  };
  
   // Group data by month for the Line chart
  const groupReportsByMonth = () => {
    const months = Array(12).fill(0);
    reports.forEach((report) => {
      const month = new Date(report.reportDate).getMonth(); // Get month from report date
      months[month]++;
    });
    return months;
  };

  // Line Chart Data for Transactions per Month
  const transactionData = {
    labels: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ],
    datasets: [
      {
        label: 'Transactions per Month',
        data: groupReportsByMonth(),
        borderColor: '#CE2E28',
        backgroundColor: 'rgba(206, 46, 40, 0.2)',
        tension: 0.4,
      },
    ],
  };
  
  // Chart options to set dimensions
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
    maintainAspectRatio: false, 
    height: 500,
    width: 500,
  };

  // Function to handle opening the modal
  const openUpdateModal = (report) => {
    setSelectedReport(report);
    setIsModalVisible(true);
  };

  // Function to handle modal close
  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedReport(null);
  };

  // Update selectAll state when current page changes
  useEffect(() => {
    const allChecked = currentReports.length > 0 && currentReports.every((report) => checkedItems[report.reportId]);
    setSelectAll(allChecked);
  }, [currentPage, checkedItems, currentReports]);
  
  const generateRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // GearVana Script Data
  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://live.callcenter.buybackbooth.com/Scripts/Gearvana/Generate_DashboardData.php?daysrange=${daysRange}`)
      .then((response) => {
        setScriptData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching script data:', error);
        setLoading(false);
      });
  }, [daysRange]);
  

  useEffect(() => {
    if (scriptData?.data) {
      setTableData(scriptData.data);
    }
  }, [scriptData]);


  // Pie chart: Transaction Status
  const transactionStatusData = {
    labels: scriptData ? Object.keys(scriptData.stats_summary.by_status) : [],
    datasets: [
      {
        label: 'Transaction Status',
        data: scriptData ? Object.values(scriptData.stats_summary.by_status) : [],
        backgroundColor: ['#CE2E28', '#CCC', '#888'],
      },
    ],
  };

  // Bar chart: Phone Brands
  const phoneBrandsData = {
    labels: scriptData ? Object.keys(scriptData.stats_summary.by_phone_brand) : [],
    datasets: [
      {
        label: 'Phone Brands',
        data: scriptData ? Object.values(scriptData.stats_summary.by_phone_brand) : [],
        backgroundColor: '#CE2E28',
      },
    ],
  };

  /// Doughnut chart: Phone Models
  const phoneModelsData = {
    labels: scriptData ? Object.keys(scriptData.stats_summary.by_phone_model) : [],
    datasets: [
      {
        label: 'Phone Models',
        data: scriptData ? Object.values(scriptData.stats_summary.by_phone_model) : [],
        backgroundColor: scriptData
          ? Object.keys(scriptData.stats_summary.by_phone_model).map(() => generateRandomColor())
          : ['#CCC'], 
      },
    ],
  };

  const phoneModelChartOptions = {
    responsive: true,
    maintainAspectRatio: false, // 💡 allow chart to grow vertically
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 12,
          padding: 16,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
  };

  const filteredData = tableData.filter((report) => {
    const phone = report.phoneInfo?.[0] || {};
    const term = searchTerm.toLowerCase();
    return (
      report.id.toLowerCase().includes(term) ||
      (phone.UID && phone.UID.toLowerCase().includes(term)) ||
      (phone.Brand && phone.Brand.toLowerCase().includes(term)) ||
      (phone.Name && phone.Name.toLowerCase().includes(term))
    );
  });


  const indexOfLast = currentPage * reportsPerPage;
  const indexOfFirst = indexOfLast - reportsPerPage;
  const currentPageData = filteredData.slice(indexOfFirst, indexOfLast);

  const exportFilteredToCSV = () => {
    const headers = ['Report ID', 'Date', 'IMEI', 'Brand', 'Model', 'Grade', 'Status'];
    const rows = filteredData.map((report) => {
    const phone = report.phoneInfo?.[0] || {};
      return [
        report.id,
        new Date(report.date_start).toLocaleString(),
        phone.UID || 'N/A',
        phone.Brand || 'N/A',
        phone.Name || 'N/A',
        phone.Grade || 'N/A',
        report.endMethod || 'N/A',
      ];
    });

    const csvContent = [headers, ...rows]
    .map(row => row.map(value => `"${value}"`).join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'dashboard_export.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="App">
      <div className="dashboard">
        <div className="container-fluid">
          <div className="row">            
          <Sidebar />            
            <div className="col-md-10 main">
            <div className='dashboard-top'>             

              <div className="buttons">
                <button className="red" onClick={goToProfile}>Account</button>
                <button className="black" onClick={userLogout}>Logout</button>
              </div>
              
              <Select
                defaultValue="365"
                style={{ width: 200, margin: '1rem 0' }}
                onChange={(value) => setDaysRange(Number(value))}
                options={[
                  { label: 'Last 24 Hours', value: '1' },
                  { label: 'Last 3 Days', value: '3' },
                  { label: 'Last 3 Months', value: '90' },
                  { label: 'Last 6 Months', value: '180' },
                  { label: 'Last Month', value: '30' },
                  { label: 'Last Year', value: '365' },
                ]}
              />
              </div>
              
              {/* Summary Stats Cards */}
              {scriptData && (
                <Row gutter={[16, 16]} className="dashboard-summary-cards" style={{ marginBottom: '20px' }}>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Total Transactions" bordered={false}>
                      <h2>{scriptData.stats_summary.total_transactions}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Total Offer Amount ($)" bordered={false}>
                      <h2>{Number(scriptData.stats_summary.total_offer_amount).toFixed(2)}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Phone Brands" bordered={false}>
                      <h2>{Object.keys(scriptData.stats_summary.by_phone_brand).length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Phone Models" bordered={false}>
                      <h2>{Object.keys(scriptData.stats_summary.by_phone_model).length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Completed Reports" bordered={false}>
                      <h2>{reports.filter((r) => r.status === 'Completed').length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Non-Completed Reports" bordered={false}>
                      <h2>{reports.filter((r) => r.status !== 'Completed').length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Valued Phones" bordered={false}>
                      <h2>{reports.filter((r) => r.value).length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card title="Non-Valued Phones" bordered={false}>
                      <h2>{reports.filter((r) => !r.value).length}</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6}>
                <Card title="Accepted Transactions" bordered={false}>
                  <h2>{scriptData.stats_summary.accepted_transactions}</h2>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card title="Declined Transactions" bordered={false}>
                  <h2>{scriptData.stats_summary.declined_transactions}</h2>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card title="Diagnostics Completed" bordered={false}>
                  <h2>{scriptData.stats_summary.diagnostics_completed}</h2>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card title="Average Offer Amount ($)" bordered={false}>
                  <h2>{Number(scriptData.stats_summary.average_offer_amount).toFixed(2)}</h2>
                </Card>
              </Col>

                </Row>
              )}

              {/* Main Dashboard Charts */}
              <div className="chart-container">
                <Card title="Valued vs Non-Valued Reports" bordered={false}>
                  <div className="pie-chart-container">
                    <Pie data={valuedVsNonValuedData} options={chartOptions} />
                  </div>
                </Card>

                <Card title="Total Reports Overview" bordered={false}>
                  <div className="bar-chart-container">
                    <Bar data={totalReportsChartData} options={chartOptions} />
                  </div>
                </Card>

                <Card title="Transaction Data" bordered={false}>
                  <div className="line-chart-container">
                    <Line data={transactionData} options={chartOptions} />
                  </div>
                </Card>

                {scriptData && (
                  <>
                    <Card title="Transaction Status" bordered={false}>
                      <div className="pie-chart-container">
                        <Pie data={transactionStatusData} options={chartOptions} />
                      </div>
                    </Card>

                    <Card title="Phone Brands Distribution" bordered={false}>
                      <div className="bar-chart-container">
                        <Bar data={phoneBrandsData} options={chartOptions} />
                      </div>
                    </Card>

              <Card title="Accepted vs Declined Transactions" bordered={false}>
                <div className="pie-chart-container">
                  <Pie
                    data={{
                      labels: ['Accepted', 'Declined'],
                      datasets: [{
                        label: 'Transaction Decision',
                        data: [
                          scriptData.stats_summary.accepted_transactions,
                          scriptData.stats_summary.declined_transactions
                        ],
                        backgroundColor: ['#28a745', '#dc3545'],
                      }],
                    }}
                    options={chartOptions}
                  />
                </div>
              </Card>

              <Card title="Phone Models Breakdown" bordered={false} className="full-width-chart">
                <div className="doughnut-chart-large-container">
                  <Doughnut data={phoneModelsData} options={phoneModelChartOptions} />
                </div>
              </Card>




                  </>
                )}
              </div>   

              <section className="reports">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-12">                    
                    <div className="input-group">
                    <span className="input-group-text"><img src={search} alt="Search" /></span>
                      <input
                      placeholder="Search by IMEI, Brand, or Model"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ width: '70%' }}
                      />                          
                      </div>

                      <div className="table-scroll-container">
                        <table className="table table-striped table-bordered align-items-center">
                        <thead>
                        <tr>
                          <th>ID</th>
                          <th>Date/Time</th>
                          <th>IMEI</th>
                          <th>Brand</th>
                          <th>Model</th>
                          <th>Device Name</th>
                          <th>Storage</th>
                          <th>Carrier</th>
                          <th>Condition</th>
                          <th>Accepted Price</th>
                          <th>Original Value</th>
                          <th>Difference</th>
                          <th>State</th>
                          <th>Location</th>
                          <th>Kiosk ID</th>
                          <th>Sales Rep</th>
                          <th>Status</th>
                          </tr>
                          </thead>

                          <tbody>
                          {currentPageData.map((report) => {
                            const phone = report.phoneInfo?.[0] || {};
                            const acceptedOffer = report.offers?.find(o => o.price > 0 && o.customPrice) || {};
                            const originalValue = acceptedOffer?.Prices?.goodPrice || 0;
                            const acceptedPrice = report.paymentMethod?.success?.OriginalAmount || 0;
                            const priceDifference = originalValue - acceptedPrice;

                            return (
                              <tr key={report.id}>                                
                                <td>{report.id}</td>
                                <td>{new Date(report.date_start).toLocaleString()}</td>
                                <td>{phone.UID || 'N/A'}</td>
                                <td>{phone.Brand || 'N/A'}</td>
                                <td>{phone.Model || phone.Name || 'N/A'}</td>
                                <td>{phone.Name || 'N/A'}</td>
                                <td>{phone.Storage || 'N/A'}</td>
                                <td>{phone.Carrier || 'N/A'}</td>
                                <td>{phone.conditions?.rejected?.reason || 'Accepted'}</td>
                                <td>${acceptedPrice.toFixed(2)}</td>
                                <td>${originalValue.toFixed(2)}</td>
                                <td>${priceDifference.toFixed(2)}</td>
                                <td>{report.KioskInfo?.Location?.State || 'N/A'}</td>
                                <td>{report.KioskInfo?.Location?.Address || 'N/A'}</td>
                                <td>{report.kioskId}</td>
                                <td>{report.sales_rep_id}</td>
                                <td>{report.endMethod || 'N/A'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      </div>
                  

                      <div className='table-bottom'>
                      <Pagination
                        current={currentPage}
                        pageSize={reportsPerPage}
                        total={filteredReports.length}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        style={{ textAlign: 'center', marginTop: '20px' }}
                      />                    
                      <>
                      <Button className="black" onClick={exportFilteredToCSV} icon={<ExportOutlined />} type="primary">
                        Export CSV
                      </Button>
                      </>
                    </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>


        <div>
          <Modal
            title="Evaluate Report"
            visible={isModalVisible}
            onCancel={handleModalClose}
            footer={null}
            className="evaluate-report-modal"
          >
            <Form
              layout="vertical"
              onFinish={(values) =>
                handleUpdateReport(
                  selectedReport?.reportId,
                  values.grade,
                  values.reason,
                  values.imageLink, // Separate field for images
                  values.videoLink // Separate field for videos
                )
              }
              initialValues={{
                grade: selectedReport?.grade ? String(selectedReport.grade) : undefined,
                reason: selectedReport?.reason ? String(selectedReport.reason) : undefined,
                imageLink: selectedReport?.imageLink ? String(selectedReport.imageLink) : undefined,
                videoLink: selectedReport?.videoLink ? String(selectedReport.videoLink) : undefined,
              }}
            >
              <Form.Item
                label="Grade"
                name="grade"
                rules={[{ required: true, message: "Please select a grade!" }]}
              >
                <Select placeholder="Select grade">
                  <Select.Option value="1">1</Select.Option>
                  <Select.Option value="2">2</Select.Option>
                  <Select.Option value="3">3</Select.Option>
                
                </Select>
              </Form.Item>

              <Form.Item
                label="Reason"
                name="reason"
                rules={[{ required: true, message: "Please provide a reason!" }]}
              >
                <Input.TextArea placeholder="Enter reason for grade change" />
              </Form.Item>

              <Form.Item
                label="Image Link (Optional)"
                name="imageLink"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL!",
                  },
                  {
                    message: "Please enter a valid image URL!",
                  },
                ]}
              >
                <Input.TextArea placeholder="Enter image link (if any)" />
              </Form.Item>

              <Form.Item
                label="Video Link (Optional)"
                name="videoLink"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL!",
                  },
                  {
                   
                    message: "Please enter a valid video URL!",
                  },
                ]}
              >
                <Input.TextArea placeholder="Enter video link (if any)" />
              </Form.Item>

              <Form.Item>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
    </div>    
  );
}

export default Dashboard;